// extracted by mini-css-extract-plugin
export default {"brandPromo":"rH-z","carousel":"sH-z"};